import { Component } from '@angular/core';

@Component({
  selector: 'app-test-report',
  standalone: true,
  imports: [],
  templateUrl: './test-report.component.html',
  styleUrl: './test-report.component.scss'
})
export class TestReportComponent {

}
